import { main, registerComponents } from '@eastsideco/salvo-ts';

// Register components with SALVO-TS
registerComponents(require.context('./components/', true), process.env.SALVO_BUILD_VARIANT);


// Initialize theme
export const theme = main({
    enableLegacySalvoLiteComponentSupport: true,
});
